import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { Link } from '@hover/blueprint';
import ArrowButton from '../../ui/ArrowButton';
import { DownloadAppModal } from '..';
import { CHAT_WITH_A_REP_DEMO_LINK } from '../../../constants';

interface Props {
  buttonType?: string;
}

const NavbarDownloadAppButton: React.FC<Props> = ({ buttonType }) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const onClose = () => setIsOpenModal(false);
  const onClick = () => setIsOpenModal(true);

  const renderButton = () => {
    switch (buttonType) {
      case 'DOWNLOAD_APP':
        return (
          <ArrowButton colorScheme="primary" variant="solid" onClick={onClick}>
            Download the App
          </ArrowButton>
        );
      case 'CHAT_WITH_A_REP':
        return (
          <ArrowButton
            colorScheme="primary"
            variant="solid"
            onClick={() => navigate(CHAT_WITH_A_REP_DEMO_LINK)}
          >
            Chat with a rep
          </ArrowButton>
        );
      case 'SCHEDULE_A_DEMO':
        return (
          <ArrowButton
            colorScheme="primary"
            color="primary.800"
            borderColor="primary.800"
            variant="outline"
            target="_blank"
            as={Link}
            href="https://calendly.com/hover-sdr/hover-website-homepage"
            textDecoration="none"
            _hover={{
              textDecoration: 'none',
              backgroundColor: 'primary.100',
              borderColor: 'primary.700',
            }}
          >
            SCHEDULE A DEMO
          </ArrowButton>
        );
      default:
        return (
          <ArrowButton colorScheme="primary" variant="solid" onClick={onClick}>
            Download the App
          </ArrowButton>
        );
    }
  };

  return (
    <>
      <DownloadAppModal isOpen={isOpenModal} onClose={onClose} />
      {renderButton()}
    </>
  );
};

NavbarDownloadAppButton.defaultProps = {
  buttonType: 'DOWNLOAD_APP',
};

export default NavbarDownloadAppButton;
